import React, { useState, useContext, useEffect } from "react";
import { siBluesky } from 'simple-icons/icons';

// Section for Utilities and Context
import "./editProfileModal.css";
import API from "../utils/API";
import { AuthContext } from "../utils/AuthContext";

// Section for Components

export default function EditOrganizationModal(props) {
    const { isAdmin } = useContext(AuthContext);
    const [imageWrongFormat, setImageWrongFormat] = useState(false);
    const [imageWrongSize, setImageWrongSize] = useState(false);
    const [isFormValid, setFormValid] = useState(false);
    const [groupTypes, setGroupTypes] = useState([]);

    const [selectedImage, setSelectedImage] = useState(undefined);
    const [organizationNameEntry, setOrganizationNameEntry] = useState("");
    const [streetAddressEntry, setStreetAddressEntry] = useState("");
    const [suiteNumberEntry, setSuiteNumberEntry] = useState("");
    const [cityEntry, setCityEntry] = useState("");
    const [stateEntry, setStateEntry] = useState("");
    const [zipCodeEntry, setZipCodeEntry] = useState("");
    const [websiteEntry, setWebsiteEntry] = useState("");
    const [lobbyFilerIdEntry, setLobbyFilerIdEntry] = useState("");
    const [mainPhoneEntry, setMainPhoneEntry] = useState("");
    const [groupTypeEntry, setGroupTypeEntry] = useState("");

    const [linkedInEntry, setLinkedInEntry] = useState("");
    const [facebookEntry, setFacebookEntry] = useState("");
    const [youtubeEntry, setYouTubeEntry] = useState("");
    const [threadsEntry, setThreadsEntry] = useState("");
    const [instagramEntry, setInstagramEntry] = useState("");
    const [tiktokEntry, setTikTokEntry] = useState("");
    const [blueskyEntry, setBlueskyEntry] = useState("");

    const showLobbyFilerId = (
        props.org_data.group_type === 'Lobbyists' || 
        props.org_data.group_type === 'Associations' || 
        props.org_data.group_type === 'Unions'
    );

    useEffect(() => {
        API.getOrganizationGroups().then(r => setGroupTypes(r.data)).catch(() => {});
    }, []);

    useEffect(() => {
        if (props.org_data.main_phone !== null) setMainPhoneEntry(formatPhoneNumber(props.org_data.main_phone));
        if (props.org_data.logo !== null) setSelectedImage(props.org_data.logo);
        if (props.org_data.organization_name !== null) setOrganizationNameEntry(props.org_data.organization_name);
        if (props.org_data.street_address !== null) setStreetAddressEntry(props.org_data.street_address);
        if (props.org_data.suite_number !== null) setSuiteNumberEntry(props.org_data.suite_number);
        if (props.org_data.city !== null) setCityEntry(props.org_data.city);
        if (props.org_data.state !== null) setStateEntry(props.org_data.state);
        if (props.org_data.zip_code !== null) setZipCodeEntry(props.org_data.zip_code);
        if (props.org_data.website !== null) setWebsiteEntry(props.org_data.website);
        if (props.org_data.lobby_filer_id !== null) setLobbyFilerIdEntry(props.org_data.lobby_filer_id);
        if (props.org_data.group_type !== null) setGroupTypeEntry(props.org_data.group_type);
        if (props.org_data.linkedin_url !== null) setLinkedInEntry(props.org_data.linkedin_url);
        if (props.org_data.facebook_url !== null) setFacebookEntry(props.org_data.facebook_url);
        if (props.org_data.youtube_url !== null) setYouTubeEntry(props.org_data.youtube_url);
        if (props.org_data.threads_url !== null) setThreadsEntry(props.org_data.threads_url);
        if (props.org_data.instagram_url !== null) setInstagramEntry(props.org_data.instagram_url);
        if (props.org_data.tiktok_url !== null) setTikTokEntry(props.org_data.tiktok_url);
        if (props.org_data.bluesky_url !== null) setBlueskyEntry(props.org_data.bluesky_url);
    }, [props]);

    // useEffect TO CHECK INPUTS TO ENABLE / DISABLE 'Save changes' BUTTON
    useEffect(() => {
        if (organizationNameEntry && streetAddressEntry) {
            setFormValid(true);
        } else {
            setFormValid(false);
        }
    }, [organizationNameEntry, streetAddressEntry]); 



    const handleImageChange = async (event) => {
        const file = event.target.files[0];
    
        // Allowed image formats: jpg, jpeg, png, gif, webp
        const validFormats = ["image/jpg", "image/jpeg", "image/png"];
        if (!validFormats.includes(file.type)) {
            setImageWrongFormat(true); // Show error message for wrong format
            return; // Exit if wrong format
        } else {
            setImageWrongFormat(false); // Reset error message
        }
    
        // Resize image 
        const resizedImage = await resizeImage(file, 450, 600);
    
        // Check size limit (example: 1MB)
        const maxSizeBytes = 5 * 1024 * 1024; // 1MB limit
        if (resizedImage.size > maxSizeBytes) {
            setImageWrongSize(true); // Show error message for file too large
            return; // Exit if image is too large
        } else {
            setImageWrongSize(false); // Reset size error message
        }
    
        const reader = new FileReader();
        reader.onloadend = () => {
            setSelectedImage(reader.result);
        };
        reader.readAsDataURL(resizedImage);

        // Create FormData to send the image to the server
        const formData = new FormData();
        formData.append("logo", resizedImage);  // Append the resized image
        formData.append("organization_id", props.org_data.organization_id);  // Append the organization_id
        formData.append("image_type", file.type);  // Append the image type
    
        try {
            const response = await API.uploadOrganizationLogo(formData);
            if (response.status === 200) {
                // setSelectedImage(imageUrl);
                console.log("Image uploaded successfully", response.data);
            } else {
                console.error("Error uploading image");
            }
        } catch (error) {
            console.error("API upload error:", error);
        }
    };

    const resizeImage = (file, maxWidth, maxHeight) => {
        return new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.onload = (event) => {
                const img = new Image();
                img.onload = () => {
                    const canvas = document.createElement('canvas');
                    const ctx = canvas.getContext('2d');
    
                    let width = img.width;
                    let height = img.height;
    
                    // Maintain aspect ratio
                    if (width > height) {
                        if (width > maxWidth) {
                            height = Math.round((height * maxWidth) / width);
                            width = maxWidth;
                        }
                    } else {
                        if (height > maxHeight) {
                            width = Math.round((width * maxHeight) / height);
                            height = maxHeight;
                        }
                    }
    
                    canvas.width = width;
                    canvas.height = height;
                    ctx.drawImage(img, 0, 0, width, height);
    
                    // Handle different image formats (e.g., jpg, png)
                    canvas.toBlob(
                        (blob) => {
                            resolve(blob); // Return resized image blob
                        },
                        file.type === 'image/png' ? 'image/png' : 'image/jpeg', // Default to JPEG for compression
                        0.8 // Adjust compression quality for JPEG
                    );
                };
                img.onerror = reject;
                img.src = event.target.result;
            };
            reader.onerror = reject;
            reader.readAsDataURL(file);
        });
    };

    // HANDLER FOR ADDING JOB EXPERIENCE TO DATABASE
    const updateOrganizationInputs = async () => {
        // e.preventDefault();
        
        try {
            const data = {
                organization_id: props.org_data.organization_id,
                organization_name: organizationNameEntry,
                street_address: streetAddressEntry,
                suite_number: suiteNumberEntry,
                city: cityEntry,
                state: stateEntry,
                zip_code: zipCodeEntry,
                website: websiteEntry,
                main_phone: mainPhoneEntry,
                lobby_filer_id: lobbyFilerIdEntry,
                linkedin_url: linkedInEntry,
                facebook_url: facebookEntry,
                youtube_url: youtubeEntry,
                threads_url: threadsEntry,
                instagram_url: instagramEntry, 
                tiktok_url: tiktokEntry,
                bluesky_url: blueskyEntry,
                ...(isAdmin && { group_type: groupTypeEntry }),
            }
            
            const response = await API.updateOrganizationInfo(data);
            props.reRenderOrganization();
            console.log("Organization info updated successfully:", response.data);
            clearModal();
        } catch(error) {
            console.error("Server request failed: ",error);
        }
    };

    // FORMAT PHONE NUMBER
    const formatPhoneNumber = (value) => {
        if (!value) return "";
        // Remove all non-numeric characters
        const cleaned = ('' + value).replace(/\D/g, '');

        // Check if the input is of correct length
        const match = cleaned.match(/^(\d{3})(\d{3})(\d{4})$/);

        if (match) {
            return `(${match[1]}) ${match[2]}-${match[3]}`;
        }

        return value;
    };

    const handleMainPhoneChange = (e) => {
        const formattedPhoneNumber = formatPhoneNumber(e.target.value);
        setMainPhoneEntry(formattedPhoneNumber);
    };

    // Function to convert a string to proper case
    const toProperCase = (str) => {
        const stopWords = ["of", "and", "the"];
    
        return str
            .toLowerCase()
            .split(" ")
            .map((word, index) => {
                if (index === 0 || !stopWords.includes(word)) {
                    // Capitalize the first character if it's the first word or not a stop word
                    return word.charAt(0).toUpperCase() + word.slice(1);
                }
                // Return the word in lowercase if it's a stop word and not the first word
                return word;
            })
        .join(" ");
    };

    const clearModal = () => {
        const fileInput = document.getElementById('formFile');
        if (fileInput) fileInput.value = '';

        setImageWrongFormat(false);
        setImageWrongSize(false);
        setOrganizationNameEntry(props.org_data.organization_name);
        setMainPhoneEntry(props.org_data.main_phone);  
        setLinkedInEntry(props.org_data.linkedin_url);
        setFacebookEntry(props.org_data.facebook_url);
        setYouTubeEntry(props.org_data.youtube_url);
        setThreadsEntry(props.org_data.threads_url);
        setInstagramEntry(props.org_data.instagram_url);
        setTikTokEntry(props.org_data.tiktok_url);
        setGroupTypeEntry(props.org_data.group_type);

    };

    return (
        <> 
            <div className="modal fade edit-bio-modal" id="editOrgProfileModal" tabIndex="-1" aria-labelledby="editOrgProfileModalLabel" aria-hidden="true">
                <div className="modal-dialog">
                    <div className="modal-content edit-profile-modal-content position-absolute top-50 start-50 translate-middle-x">
                        <div className="modal-header edit-bio-modal-header">
                            <h5 className="modal-title modal-title display-6">Edit Organization Information</h5>
                        </div>
                        <div className="modal-body px-4">
                            <div className="edit-profile-body ">
                                
                                <div className="row profile-picture-div">
                                    <div className="col-md-3 ps-5 pe-0">
                                        <img className="picture-thumbnail rounded" src={selectedImage} alt="Organization logo preview"/>
                                    </div>
                                    <div className="col-md-9 ps-md-4">
                                        <div className="input-group-sm mt-4 pt-1">
                                            <label htmlFor="formFile" className="form-label">Upload organization logo</label>
                                            <span className="picture-type-limit ms-2">{"( .jpg, .jpeg, and .png only )"}</span>
                                            <input className="form-control" type="file" id="formFile" accept=".jpg, .jpeg, .png" onChange={handleImageChange} />
                                        </div>
                                        {imageWrongFormat === true && (
                                            <span className="image-upload-issue">Incorrect image format. Please select only .jpg or .jpeg.</span>
                                        )}
                                        {imageWrongSize === true && (
                                            <span className="image-upload-issue">Image is too large. Please resize or select a smaller image.</span>
                                        )}
                                    </div>
                                </div>
                                <div className="row mt-3">
                                    <div className="input-group mb-1 input-group-sm">
                                        <input
                                            className="form-control" 
                                            aria-label="With textarea"
                                            placeholder="Organization Name"
                                            value={organizationNameEntry || ""}
                                            onChange={(e) => setOrganizationNameEntry(e.target.value)}
                                        />
                                    </div>
                                    
                                </div>

                                <div className="input-group py-1">
                                    <div className="row address-row">
                                        <div className="col-9 px-0 me-0 input-group-sm">
                                            <input 
                                                type="text" 
                                                className="form-control" 
                                                placeholder="Address*"
                                                value={streetAddressEntry || ""}
                                                onChange={(e) => setStreetAddressEntry(toProperCase(e.target.value))}
                                            />
                                        </div>
                                        <div className="col-3 pe-0 me-0 input-group-sm">
                                            <input 
                                                type="text" 
                                                className="form-control" 
                                                placeholder="Suite #"
                                                value={suiteNumberEntry || ""}
                                                onChange={(e) => {setSuiteNumberEntry(e.target.value)}}
                                            />
                                        </div>
                                    </div>
                                </div>
                                <div className="input-group  py-1">
                                    <div className="row">
                                        <div className="col-6 pe-0 me-0 input-group-sm">
                                            <input 
                                                type="text" 
                                                className="form-control" 
                                                placeholder="City*"
                                                value={cityEntry || ""}
                                                onChange={(e) => {setCityEntry(toProperCase(e.target.value))}}
                                            />
                                        </div>
                                        <div className="col-3 pe-0 me-0 input-group-sm">
                                            <input 
                                                type="text" 
                                                className="form-control" 
                                                placeholder="State*"
                                                value={stateEntry || ""}
                                                onChange={(e) => {setStateEntry(e.target.value.toUpperCase())}}
                                            />
                                        </div>
                                        <div className="col-3 input-group-sm">
                                            <input 
                                                type="text" 
                                                className="form-control" 
                                                aria-label="" 
                                                placeholder="ZIP*"
                                                value={zipCodeEntry || ""}
                                                onChange={(e) => setZipCodeEntry(e.target.value)}
                                            />
                                        </div>
                                    </div>
                                </div>
                                <div className="row py-1">
                                    <div className="input-group input-group-sm ">
                                        <span className="input-group-text phone-span"><i className="bi bi-globe"/>&nbsp;Website</span>
                                        <input
                                            className="form-control" 
                                            placeholder="Organization URL"
                                            value={websiteEntry || ""}
                                            onChange={(e) => setWebsiteEntry(e.target.value)}
                                        />
                                    </div>
                                </div>
                                <div className="row py-1">
                                    <div className="col-md-6">
                                        <div className="input-group  input-group-sm mb-2">
                                            <span className="input-group-text phone-span"><i className="bi bi-telephone"/>&nbsp;Phone</span>
                                            <input
                                                className="form-control" 
                                                placeholder="916-555-0123"
                                                value={mainPhoneEntry || ""}
                                                onChange={handleMainPhoneChange}
                                            />
                                        </div>
                                    </div>
                                    <div className="col-md-6">
                                        {props && showLobbyFilerId && (
                                            <div className="input-group  input-group-sm mb-2">
                                                <span className="input-group-text lobby-id-span"><i className="bi bi-bank"/>&nbsp;Cal-Access ID</span>
                                                <input
                                                    className="form-control"
                                                    value={lobbyFilerIdEntry || ""}
                                                    onChange={(e) => setLobbyFilerIdEntry(e.target.value)}
                                                    disabled={!isAdmin && props?.org_data?.lobby_filer_id !== null}
                                                />
                                            </div>
                                        )}
                                        
                                    </div>
                                </div>

                                {isAdmin && (
                                    <div className="row ">
                                        <div className="col-md-6">
                                            <div className="input-group input-group-sm mb-2 ">
                                                <span className="input-group-text">Group Type</span>
                                                <select
                                                    className="form-select"
                                                    value={groupTypeEntry || ""}
                                                    onChange={(e) => setGroupTypeEntry(e.target.value)}
                                                >
                                                    <option value="" disabled>Select a type</option>
                                                    {[...groupTypes]
                                                        .sort((a, b) => a.group_name.localeCompare(b.group_name))
                                                        .map((g) => (
                                                            <option key={g.group_id} value={g.group_name}>{g.group_name}</option>
                                                        ))}
                                                    <option value="Other">Other</option>
                                                </select>
                                            </div>
                                        </div>
                                    </div>
                                )}

                                <div className="row mt-3 pb-0 mb-0">
                                    <h5 className="display-6 socials-title">Socials Links</h5>
                                    <div className="col-md-6">
                                        <div className="input-group input-group-sm mb-2">
                                            <span className="input-group-text pci-socials-edit pci-socials-linkedin"><i className="bi bi-linkedin"/></span>
                                            <input
                                                className="form-control" 
                                                aria-label="With textarea"
                                                placeholder="LinkedIn"
                                                value={linkedInEntry || ""}
                                                onChange={(e) => setLinkedInEntry(e.target.value)}
                                            />
                                        </div>
                                        <div className="input-group input-group-sm mb-2">
                                            <span className="input-group-text pci-socials-facebook"><i className="bi bi-facebook"/></span>
                                            <input
                                                className="form-control" 
                                                aria-label="With textarea"
                                                placeholder="Facebook"
                                                value={facebookEntry || ""}
                                                onChange={(e) => setFacebookEntry(e.target.value)}
                                            />
                                        </div>
                                        <div className="input-group input-group-sm mb-2">
                                            <span className="input-group-text pci-socials-youtube"><i className="bi bi-youtube"/></span>
                                            <input
                                                className="form-control" 
                                                aria-label="With textarea"
                                                placeholder="YouTube"
                                                value={youtubeEntry || ""}
                                                onChange={(e) => setYouTubeEntry(e.target.value)}
                                            />
                                        </div>
                                        <div className="input-group input-group-sm mb-2">
                                            <span className="input-group-text pci-socials-bluesky">
                                                <svg
                                                    role="img"
                                                    viewBox="0 0 24 24"
                                                    xmlns="http://www.w3.org/2000/svg"
                                                    className="bluesky-inline-icon"
                                                    style={{ height: '1em',  fill: "#0088ff" }}
                                                >
                                                    <title>{siBluesky.title}</title>
                                                    <path d={siBluesky.path} />
                                                </svg>
                                            </span>
                                            <input
                                                className="form-control"
                                                aria-label="With textarea"
                                                placeholder="Bluesky"
                                                value={blueskyEntry || ""}
                                                onChange={(e) => setBlueskyEntry(e.target.value)}
                                            />
                                        </div>
                                    </div>
                                    <div className="col-md-6">
                                        <div className="input-group input-group-sm mb-2">
                                            <span className="input-group-text pci-socials-threads"><i className="bi bi-threads"/></span>
                                            <input
                                                className="form-control" 
                                                aria-label="With textarea"
                                                placeholder="Threads"
                                                value={threadsEntry || ""}
                                                onChange={(e) => setThreadsEntry(e.target.value)}
                                            />
                                        </div>
                                        <div className="input-group input-group-sm mb-2">
                                            <span className="input-group-text pci-socials-instagram"><i className="bi bi-instagram"/></span>
                                            <input
                                                className="form-control" 
                                                aria-label="With textarea"
                                                placeholder="Instagram"
                                                value={instagramEntry || ""}
                                                onChange={(e) => setInstagramEntry(e.target.value)}
                                            />
                                        </div>
                                        <div className="input-group input-group-sm mb-2">
                                            <span className="input-group-text pci-socials-tiktok"><i className="bi bi-tiktok"/></span>
                                            <input
                                                className="form-control" 
                                                aria-label="With textarea"
                                                placeholder="TikTok"
                                                value={tiktokEntry || ""}
                                                onChange={(e) => setTikTokEntry(e.target.value)}
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="modal-footer pt-0">
                            <button type="button" className="btn modal-close" data-bs-dismiss="modal" alt="Button to close modal">Close</button>
                            <div className={isFormValid ? "" : "disabled-button"}>
                                <button 
                                    type="button" 
                                    className="btn modal-save" 
                                    alt="Button to save changes to bio"
                                    data-bs-dismiss="modal" 
                                    onClick={updateOrganizationInputs}
                                    disabled={!isFormValid}
                                >Save changes</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
           
        </>
    )
}